// @flow
import StorageService from './Storage.service';

export default new StorageService(localStorage);
